export const INVALID_WORD = 'INVALID_WORD';
export const CORRECT_ANSWER = 'CORRECT_ANSWER';
export const INCORRECT_ANSWER = 'INCORRECT_ANSWER';
export const INCOMPLETE_ANSWER = 'INCOMPLETE_ANSWER';
